import React from 'react'
import { ApplicationFlowHeader } from '../components'
import { MatchingSkinProps } from '../types'
import themeStyles from '../theme/application-flow-theme.module.scss'
import styles from './matching-skin.module.scss'

/**
 * MatchingSkin — 提交后的匹配等待纯展示皮肤
 * @returns {React.ReactElement} 匹配等待展示节点
 */
const MatchingSkin: React.FC<MatchingSkinProps> = React.memo(({ model, onBack, theme }) => (
  <main className={themeStyles.themeRoot} data-theme={theme.name}>
    <section className={styles.page}>
      <ApplicationFlowHeader onBack={onBack} title="" visualType="solid" />
      <div className={styles.content}>
        <div className={styles.illustrationWrap}>
          <img alt="" className={styles.illustration} height="179" src={theme.matchingIllustration} width="183" />
          <span aria-hidden="true" className={styles.scanOrbit}>
            <span className={styles.scanBeam} />
          </span>
          <img alt="" className={styles.shield} height="45" src={theme.matchingShield} width="37" />
        </div>
        <h1>资料加密处理中，请耐心等待</h1>
        <ol className={styles.progress}>
          {model.progressSteps.map((label, index) => {
            let stateClassName = ''
            if (index < model.currentStep) {
              stateClassName = styles.done
            } else if (index === model.currentStep) {
              stateClassName = styles.current
            }
            return (
              <li className={stateClassName} data-testid={`matching-step-${index}`} key={label}>
                <span aria-hidden="true" className={styles.node}>{index < model.currentStep ? '✓' : ''}</span>
                <span>{label}</span>
              </li>
            )
          })}
        </ol>
      </div>
    </section>
  </main>
))

MatchingSkin.displayName = 'MatchingSkin'

export default MatchingSkin
